/* tslint:disable */
import { Component, OnInit, Inject, Input, OnChanges } from '@angular/core';
import { Config } from '../universal-config';

@Component({
  selector: 'google-analytics',
  template: ''
})
export class GoogleAnalyticsComponent implements OnInit, OnChanges{
  @Input() profile;

  isEnabled = false;
  userId = '???';

  constructor(
    public _config: Config,
    @Inject('isBrowser') public isBrowser: boolean
  ) { }

  ngOnInit() {
    if (this.isBrowser) {
      const gtagAppId = this._config.get('GTAG_ID');
      const alteredGtagId = this._config.get('ALTERED_GTAG_ID');
      const gtmId = this._config.get('GTM_ID');

      if (alteredGtagId) {
        this.insertGtag(alteredGtagId);
        this.setupGtag({ resourceId: alteredGtagId, transportUrl: 'https://stt.nimbusweb.me' });
        if (gtagAppId) {
          this.setupGtag({ resourceId: gtagAppId });
        }
      }

      if (gtmId)  {
        this.insertGTM(gtmId)
      }
    }
  }

  ngOnChanges(changes) {
    if(changes.profile && changes.profile.currentValue && this.isBrowser) {
      this.setupUserId(changes.profile.currentValue.userId);
    }
  }

  insertGtag(resourceId) {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = `https://stt.nimbusweb.me/gtag/js?id=${ resourceId }`;
    script.async = true;
    gtag('js', new Date());
    this.isEnabled = true;
    this.insertScript(script);
  }

  setupGtag(config) {
    const { resourceId, transportUrl } = config;
    const gtagConfig: any = {
      link_attribution: true,
      linker: { domains: ['everhelper.me'] },
    };
    if (transportUrl) {
      gtagConfig.transport_url = transportUrl;
    }
    gtag('config', resourceId, gtagConfig);
  }

  insertGTM(resourceId) {
    const script: HTMLScriptElement = document.createElement('script')
    script.src = `https://stt.nimbusweb.me/gtlytics.js?id=${ resourceId }`
    script.async = true
    this.insertScript(script)
  }

  setupUserId(userId) {
    this.userId = `${ userId }`;
    gtag('set', {
      custom_map: { dimension1: this.userId },
      user_id: this.userId,
    });
  }

  private insertScript(script: HTMLScriptElement) {
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }

}
